module.exports = __webpack_public_path__ + "static/media/fully-customised.ffa752d3.svg";